import React, { useState, useEffect, useRef, useMemo } from "react";
import PreLoginBanner from "../component/PreLoginBanner";
import PurpleHeading from "../component/PurpleHeading";
import SelectDropDown from "../component/SelectDropDown";
import SelectDropDownNew from "../component/SelectDropDownNew";
import InputField from "../component/InputField";
import PrimaryGradientButton from "../component/PrimaryGradientButton";
import PrimaryOutLineButton from "../component/PrimaryOutLineButton";
import { Link } from "react-router-dom";
import OTPBox from "../component/OTPBox";
import RegistrationUserInputField from "../component/RegistrationUserInputField";
import RegistrationService from "../services/registration";
import ProfileService from "../services/Profile";
import UploadFile from "../component/UploadFile";
import { useNavigate } from "react-router-dom";
import AlertMsg from "../component/AlertMsg";
import NotificationService from "../services/Notification";
import DatePicker from "../component/DatePicker";
import toast from 'react-hot-toast';
import { ddmmyyyyToyyyymmdd, validateDoc } from "../constants/commonFunction";
import DOMPurify from "dompurify";
import { parseSafeHtml } from "../utils/safeHtmlParser";

const Registration = () => {
  //OTP BOX
  const [pin1, setPin1] = useState("");
  const [pin2, setPin2] = useState("");
  const [pin3, setPin3] = useState("");
  const [pin4, setPin4] = useState("");
  const [pin5, setPin5] = useState("");
  const [pin6, setPin6] = useState("");
  const [documentType, setdocumentType] = useState([]);
  const [selectedKYC, setSelectedKYC] = useState({id: "", title: ""});
  const [isOTPBlock, setIsOTPBlock] = useState(false);
  const [panImage, setPanImage] = useState(null);
  const [frontImage, setFrontImage] = useState(null);

  const [backImage, setBackImage] = useState("");
  const [profileImage, setProfileImage] = useState(null);
  const [nameValidationError, setNameValidationError] = useState("");
  const [personaValidationError, setPersonaValidationError] = useState("");
  const [brandValidationError, setBrandValidationError] = useState("");
  const [kycValidationError, setKycValidationError] = useState("");
  const [kycUplodBlock, setKycUploadBlock] = useState(false);
  const [kycDetailsValidationError, setKycDetailsValidationError] = useState("");
  const [previewBlock, setPreviewBlock] = useState(false);
  const [regFormBlock, setRegFormBlock] = useState(true);
  const [persona, setPersona] = useState([]);
  const [isbrand, setIsBrand] = useState([]);
  const [allState, setAllState] = useState([]);
  const [allDistrict, setAllDistrict] = useState([]);
  const [allTaluka, setAllTaluka] = useState([]);
  const [isLoginSuccess, setIsLoginSuccess] = useState({
    isLogin: true,
    heading: "",
    text: "",
  });
  const [showAlert, setShowAlert] = useState(false);
  const [showAlertOTP, setShowAlertOTP] = useState(false);
  const [mobileNoVerified, setMobileNoVerified] = useState(false)
  //First Name Validate
  const [isFullNameValid, setIsFullNameValid] = useState(true);
  // Mobile number validation function
  // const [address, setAddress] = useState("");
  const [mobileValidationError, setMobileValidationError] = useState("");
  const [mobileOTPValidationError, setMobileOTPValidationError] = useState("");
  const [selectedPersona, setSelectedPersona] = useState({ id: "", title: "" });
  const [selectedBrand, setSelectedBrand] = useState({ id: "", title: "" });
  const [selectedCountry, setSelectedCountry] = useState({ id: "", title: "" });
  const [selectedState, setSelectedState] = useState({ id: "", title: "" });
  const [selectedDistrict, setSelectedDistrict] = useState({ id: "", title: "" });
  const [selectedTaluka, setSelectedTaluka] = useState({ id: "", title: "" });
  const [selectedOfficer, setSelectedOfficer] = useState({ id: "", title: "" });
  const [selectedOffMember, setSelectedOffMember] = useState({ id: "", title: "" });
  const [selectedMarritalStatus, setSelectedMarritalStatus] = useState({ id: "", title: "" });
  const [spouseName, setSpouseName] = useState("");
  const [spouseDoB, setSpouseDoB] = useState("");
  const [userDoB, setUserDoB] = useState("");
  const [allOffMember, setAllOffMember] = useState([]);
  const [isOTP, setIsOTP] = useState("");
  const [verifyOtpToken, setVerifyOtpToken] = useState("")

  // added in march 13
  const [verifyPhoneNumberObject, setVerifyPhoneNumberObject] = useState(null);
  const [isKYCVerified, setIsKYCVerified] = useState(false);
  const [isKYCVerifying, setIsKYCVerifying] = useState(false);
  const [isNameReadOnly, setIsNameReadOnly] = useState(false);
  const [fetchKYCInfoResponse, setFetchKYCInfoResponse] = useState(null);
  const [showOtpSubmitAlert, setshowOtpSubmitAlert] = useState(false);
  const [otpSubmitalertObject, setOtpSubmitalertObject] = useState({});
  const [showRegistrationAlert, setShowRegistrationAlert] = useState(false);
  const [registrationSubmitResponse, setregistrationSubmitResponse] =
    useState(null);
  const [errorMessagesAfterRegistration, setErrorMessagesAfterRegistration] =
    useState([]);
    const [marriageAnniversary, setMarriageAnniversary] = useState("")
  const [emailValidationError, setEmailValidationError] = useState("");
  const [fileNotUploadedAlert, setfileNotUploadedAlert] = useState('');
  const [fileNotUploadedFrontAlert, setfileNotUploadedFrontAlert] = useState('');
  const [fileNotUploadedBackAlert, setfileNotUploadedBackAlert] = useState('');
  const [profilePicNotUploadedAlert, setProfilePicNotNotUploadedAlert] = useState('');
  const [checkBoxValidationAlert, setCheckBoxValidationAlert] = useState('');
  const [agreedCheckBoxValidationAlert, setAgreedCheckBoxValidationAlert] = useState('');
  const [isChecked, setIsChecked] = useState();
  const [isAgreedChecked, setIsAgreedChecked] = useState();
  const [termsContent, setTermsContent] = useState('');
  // const [termsContent, setTermsContent] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [disabledBlock, setDisabledBlock] = useState(true);

  const [info, setInfo] = useState(1);
  const navigate = useNavigate();

  const [user, setUser] = useState({
    nameKYC: "",
    mobile: "",
    selectKYC: "",
    kycDetails: "",
    email: "",
    refeferalCode: "",
    useraddress: "",
    spouseName: ""
  });
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  const modalRef = useRef(null);
  
  const documentTypeOptions = useMemo(() => [
    {
      title: 'Voter ID',
      id: 'voterId',
      fetchDocId: 6
    },
    {
      title: 'Driving License',
      id: 'driving_license',
      fetchDocId: 7
    },
    {
      title: 'PAN',
      id: 'pan',
      fetchDocId: 2
    },
  ], []);

  useEffect(() => {
    const fetchData = async () => {
      if (localStorage.getItem('access_token')) {
        navigate("/landing")
      }
      try {
        // Fetch Hierarchies
        const hierarchiesResponse = await RegistrationService.getHierarchies();
        const allHierarchies = hierarchiesResponse.response.hierarchiesDetails;
        const contractorOnly = allHierarchies
            .filter(item => item.name === "CONTRACTOR")
            .map(item => ({
              id: item.id,
              title: item.name
            }));
        

        const hierarchies = hierarchiesResponse.response.hierarchiesDetails.map(
          (item) => ({
            id: item.id,
            title: item.name,
          })
        );
        setPersona(contractorOnly);

        // Fetch Brands
        const brandResponse = await ProfileService.getBrand();
        const brands = brandResponse.response.message.map((item) => ({
          id: item.brandId,
          title: item.brandName,
        }));
        setIsBrand(brands);

        // Fetch KYC Types
        const kycTypeResponse = await RegistrationService.kycType();
        const kycList = kycTypeResponse.response.KYCTypes;

        setdocumentType(kycList);
      } catch (error) {
      }
    };

    fetchData();
  }, []);

  const maritalStatusList = [
    {
      id: 'Married',
      title: 'Married',
    },
    {
      id: 'Single',
      title: 'Single',
    },
  ];

  //Functions
  const checkKycDetailsValid = () => {
    if (
      user.kycDetails == "" ||
      user.selectKYC == "" ||
      kycDetailsValidationError !== ""
    ) {
      return true;
    }
  };

  function getStateList(cid) {
    RegistrationService.allStates(cid)
      .then(res => {
        if (res.success) {
          //let data=JSON.stringify(res)

          const allState = res.response.statesDetails
            // .filter(item => ['Delhi', 'Goa', 'West Bengal'].includes(item.name))
            .map(item => ({id: item.id, title: item.name}));

          setAllState(allState);
        } else {
          const obj = res.response.error;
        }

      })
      .catch(err => {
      });
  };

  function getCountryList() {
    RegistrationService.allCountries()
      .then(res => {

        if (res.success) {
          //let data=JSON.stringify(res)

          const allCountries = res.response.countriesDetails
            .filter(item => ['India'].includes(item.name))
            .map(item => ({id: item.id, title: item.name}));

          // setCountrieslist(allCountries);
          setSelectedCountry(allCountries[0]);
        } else {
          const obj = res.response.error;
        }
      })
      .catch(err => {
      });
  };

  useEffect(() => {
    getCountryList();
  }, []);
  useEffect(() => {
    if (selectedCountry.id) {
      getStateList(selectedCountry.id);
    }
  }, [selectedCountry]);

  useEffect(() => {
    setSelectedDistrict({id: '', title: ''});
    setSelectedTaluka({id: '', title: ''});
    setSelectedOfficer({id: '', title: ''});
    setSelectedOffMember({id: '', title: ''});
    setAllTaluka([]);
  }, [selectedState]);

  useEffect(() => {
    setSelectedTaluka({id: '', title: ''});
    setSelectedOfficer({id: '', title: ''});
    setSelectedOffMember({id: '', title: ''});
  }, [selectedDistrict]);

  useEffect(() => {
    setSelectedOfficer({id: '', title: ''});
    setSelectedOffMember({id: '', title: ''});
  }, [selectedTaluka]);

  useEffect(() => {
    setSelectedOffMember({id: '', title: ''});
  }, [selectedOfficer]);

  useEffect(() => {
    // EncryptedStorage.getItem('my-key').then(token => {
    if (selectedState.id && selectedCountry.id) {
      RegistrationService.allDistricts(selectedCountry.id, selectedState.id).then(res => {
        if (res.success) {
          const districts = res.response.districtDetails.map(dis => ({
            id: dis.id,
            title: dis.name,
          }));
          // if (hierDesc !== 'Dealer' && hierDesc !== 'TSE') {
          setAllDistrict(districts);
          // } else {
          //   setAllDistrictCopy(districts);
          // }
        }
      });
    }
    // });
  }, [selectedState, selectedCountry]);

  useEffect(() => {
    // setSelectedTaluka({id: "", title: ""})
    if (selectedDistrict.id) {
      // EncryptedStorage.getItem('my-key').then(token => {
       RegistrationService.talukasByDistrict(selectedDistrict.id).then(res => {
        if (res.success) {
          const talukas = res.response.talukaDetails.map(taluka => ({
            id: taluka.id,
            title: taluka.name,
          }));

          setAllTaluka(talukas);
        }
      });
      // });
    }
  }, [selectedDistrict]);

  useEffect(() => {
    if (selectedBrand.id && selectedTaluka.id && selectedDistrict.id && selectedOfficer.id) {
      const payload = {
        userContactId: 0,
      };
      // EncryptedStorage.getItem('my-key').then(token => {
        RegistrationService.getDealersOrTse(
          selectedOfficer.id,
          selectedDistrict.id,
          selectedTaluka.id,
          selectedBrand.id,
          payload,
        )
          .then(res => {
            // setAllOffMember([]);
            if (res.success) {
              let offs;

              if (selectedOfficer?.id == 'TSE') {
                offs = res.response.adminDetails.map(off => ({
                  id: off.id,
                  title: off.full_name,
                }));
              } else {
                offs = res.response.adminDetails.map(off => ({
                  id: off.id,
                  title: `${off.full_name} (${off?.company} - ${off?.id_extern01})`,
                }));
              }

              setAllOffMember(offs);
            }
          })
          .catch(err => {
          });
      // });
    }
  }, [selectedBrand, selectedOfficer, selectedDistrict, selectedTaluka]);

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked)
    setCheckBoxValidationAlert('')
  };
  const handleAgreeCheckboxChange = (e) => {
    setIsAgreedChecked(e.target.checked)
    setAgreedCheckBoxValidationAlert('')
  };
  const handlePersonaChange = (selectedValue) => {
    setSelectedPersona(selectedValue);
    setPersonaValidationError("");
  };

  const handleBrandChange = (selectedValue) => {
    setSelectedBrand(selectedValue);
    setBrandValidationError("");
  };

  const handleKYCChange = (selectedValue) => {
    setSelectedKYC(selectedValue);
    setUser({
      ...user,
      nameKYC: "",
      mobile: user.mobile,
      selectKYC: selectedValue.id,
      kycDetails: "",
      email: user.email,
      spouseName: user.spouseName
      // date_of_birth: user.date_of_birth
    });
    setPanImage(null);
    setFrontImage(null);
    setBackImage(null);
    setProfileImage(null);
    setKycUploadBlock(false);
    setKycValidationError("");
  };

  const isValidKyc = (selectKYC, kycDetails) => {

		// Validate KYC Adhar details
		if (selectKYC === "aadharcard") {
			const idRegex = /^[a-zA-Z0-9]{12}$/; // Aadhar card regex
			if (!idRegex.test(kycDetails)) {
				setKycDetailsValidationError("Invalid aadhar card number.");
			} else {
				setKycDetailsValidationError(""); // Reset error message if validation passes
			}
		}
		// Validate KYC Voter details
		if (selectKYC === "voterId") {
			// const idRegex = /^[A-Z]{3}\d{7}$/; // Voter card regex
      const idRegex = /^[A-Z]{3}[0-9]{7}$/; 
			if (!idRegex.test(kycDetails)) {
				setKycDetailsValidationError("Invalid Voter Id number");
			} else {
				setKycDetailsValidationError(""); // Reset error message if validation passes
			}
		}
		// Validate KYC driving license details
		if (selectKYC === "driving_license") {
			const idRegex = /^[A-Za-z0-9]{1,20}$/; // Driving License card regex
			if (!idRegex.test(kycDetails)) {
				setKycDetailsValidationError("Invalid driving license number.");
			} else {
				setKycDetailsValidationError(""); // Reset error message if validation passes
			}
		}
		// Validate KYC PAN Card details
		if (selectKYC === "pan") {
			const idRegex = /^[A-Z]{5}\d{4}[A-Z]$/; // PAN card regex
			if (!idRegex.test(kycDetails)) {
				setKycDetailsValidationError("Invalid PAN card number.");
			} else {
				setKycDetailsValidationError(""); // Reset error message if validation passes
			}
		}

		if(kycDetailsValidationError !== ''){

			return false;
		} else {
			return true;
		}
	}

  const handleRegistrationInputs = (e) => {
    
    setUser(p => ({ ...p, [e.target.name]: e.target.value }));
    if (e.target.name === "nameKYC") {
      let sanitizedValue = e.target.value.replace(/[^a-zA-Z\s]/g, '');
      e.target.value = sanitizedValue;
      setNameValidationError("");
    } else if (e.target.name === "mobile") {
      // Remove non-numeric characters
      let sanitizedValue = e.target.value.replace(/[^0-9]/g, '');
            
      // Limit the length to 10 digits
      if (sanitizedValue.length > 10) {
          sanitizedValue = sanitizedValue.slice(0, 10);
      }
      
      // Update the input value and state
      e.target.value = sanitizedValue;
      setUser((prev) => ({ ...prev, mobile: sanitizedValue }));
      setMobileValidationError("");
    } else if (e.target.name === "kycDetails") {
      setKycDetailsValidationError("");
    }

    //Email validation
    if (e.target.name == "email") {
      debugger
      let check = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        e.target.value
      )
      !check ? setEmailValidationError("Invalid email") : setEmailValidationError("")
      if (e.target.value == "") {
        setEmailValidationError("")
      }
    }

    isValidKyc(selectedKYC.id, e.target.value);

    // // Validate KYC Adhar details
    // if (selectedKYC.id === "aadharcard" && e.target.name === "kycDetails") {
    //   const idRegex = /^(\d{12})$/; // Aadhar card regex
    //   if (!idRegex.test(e.target.value)) {
    //     setKycDetailsValidationError("Invalid aadhar card number.");
    //   } else {
    //     setKycDetailsValidationError(""); // Reset error message if validation passes
    //   }
    // }
    // // Validate KYC Voter details
    // if (selectedKYC.id === "voterId" && e.target.name === "kycDetails") {
    //   const idRegex = /^[A-Z]{3}\d{7}$/; // Voter card regex
    //   if (!idRegex.test(e.target.value)) {
    //     setKycDetailsValidationError("Invalid Voter Id number");
    //   } else {
    //     setKycDetailsValidationError(""); // Reset error message if validation passes
    //   }
    // }
    // // Validate KYC driving license details
    // if (
    //   selectedKYC.id === "driving_license" &&
    //   e.target.name === "kycDetails"
    // ) {
    //   const idRegex = /^[A-Za-z0-9]{1,20}$/; // Driving License card regex
    //   if (!idRegex.test(e.target.value)) {
    //     setKycDetailsValidationError("Invalid driving license number.");
    //   } else {
    //     setKycDetailsValidationError(""); // Reset error message if validation passes
    //   }
    // }
    // // Validate KYC PAN Card details
    // if (selectedKYC.id === "pan" && e.target.name === "kycDetails") {
    //   const idRegex = /^[A-Z]{5}\d{4}[A-Z]$/; // PAN card regex
    //   if (!idRegex.test(e.target.value)) {
    //     setKycDetailsValidationError("Invalid PAN card number.");
    //   } else {
    //     setKycDetailsValidationError(""); // Reset error message if validation passes
    //   }
    // }
  };

  const dealerOrTse = [
    {
      id: 'TSE',
      title: 'TSE/TE',
    },
    {
      id: 'Dealer',
      title: 'Dealer',
    },
  ];

  //Phone No  Verification
  const handleOTPSubmit = async () => {
    if(!user.mobile) {
      // setMobileValidationError("Kindly enter your mobile number")
      toast.error("Kindly enter your mobile number")
      return
    }
    setPin1("")
    setPin2("")
    setPin3("")
    setPin4("")
    setPin5("")
    setPin6("")

    if (!isValidMobileNumber(user.mobile)) {
      // setMobileValidationError("Invalid mobile number.");
      toast.error("Invalid mobile number.");
      return;
    }
    // setIsOTPBlock(true);
    // const payload = {
    //   channel: "sms",
    //   send_to: String(user.mobile),
    //   user_id: 0,
    //   applicationCode: "rewardsConnect",
    //   subapplicationCode: selectedBrand.id == 1 ? "accltd" : "ambuja",
    //   templateCode: "sendOtpMobile",
    //   valid_for: 5
    // };

    // RegistrationService.verifyPhone(payload)
    //   .then((res) => {
    //     setVerifyPhoneNumberObject(res);
    //     setShowAlert(true);
    //     setTimeout(() => {
    //       setShowAlert(false);
    //     }, 3000);
    //   })
    //   .catch((error) => {

    //   });
    try {
      const payload = {
        mobile_number: String(user.mobile),
        brand_id: selectedBrand.id,
      };
      const res = await RegistrationService.sendOTPSignup(payload)
      if (res.success && res.response.status === "true") {
        // setShowAlertOTP(true);
        // setIsLoginSuccess({ isLogin: true, text: '6 digit OTP has been sent' });
        toast.success('6 digit OTP has been sent')
        setIsOTPBlock(true)
        // setTimeout(() => {
        //   setShowAlertOTP(false);
        // }, 2000)

      }
      else {
        toast.error(res.response.message);
        setIsOTPBlock(false)
        // setShowAlertOTP(true);
        // setIsLoginSuccess({ isLogin: false, text: res.response.message });
        // setTimeout(() => {
        //   setShowAlertOTP(false);
        // }, 2000)
      }
    }
    catch (e) {
    }
  };

  //OTP Resubmit
  const handleOTPReSubmit = async () => {
    const payload = {
      channel: "sms",
      send_to: String(user.mobile),
      user_id: 0,
      applicationCode: "rewardsConnect",
      subapplicationCode: selectedBrand.id == 1 ? "accltd" : "ambuja",
      templateCode: "sendOtpMobile",
      valid_for: 5
    };
    try {
      const OTPSendResponse = await NotificationService.sendOtp(payload)
      if (OTPSendResponse && OTPSendResponse.error == false && OTPSendResponse.apiResponse == 'success') {
        setShowAlertOTP(true);
        setIsOTPBlock(true);
        toast('6 digit OTP has been sent')
        setIsLoginSuccess({ isLogin: true, text: '6 digit OTP has been sent' });
        setTimeout(() => {
          setShowAlertOTP(false);
        }, 2000)

      }
      else {
        setShowAlertOTP(true);
        toast('Please try again')
        setIsLoginSuccess({ isLogin: false, text: 'Please try again' });
        setTimeout(() => {
          setShowAlertOTP(false);
        }, 2000)
      }
    }
    catch (e) {
    }
  }
  const otpValueFromField = Number(pin1 + pin2 + pin3 + pin4 + pin5 + pin6);
  //OTP Verification
  const handleOTPSubmitSuceess = async () => {
    if (pin1 && pin2 && pin3 && pin4 && pin5 && pin6) {
      // const payload = {
      //   "channel": "sms",
      //   "send_to": user.mobile,
      //   "user_id": 0,
      //   "applicationCode": "rewardsConnect",
      //   "subapplicationCode": selectedBrand.id == 1 ? "accltd" : "ambuja",
      //   "otp": Number(otpValueFromField)
      // }
      const payload = {
        mobile_number: user.mobile,
        brand_id: selectedBrand.id,
        otp: Number(otpValueFromField),
      }
      try {
        const res = await NotificationService.verifyOtp(payload)
        if (res.success) {
          if (res.response.status == 'true') {
            toast.success(res.response.message)
            setVerifyOtpToken(res.response.otpDetails.token);
            setMobileNoVerified(true)
            setIsOTPBlock(false);
            // setOtpSubmitalertObject({ type: 'successAlert', text: 'OTP verification successful' })
            // setshowOtpSubmitAlert(true);
            // setTimeout(() => {
            //   setshowOtpSubmitAlert(false);
            //   setOtpSubmitalertObject({})
            // }, 3000);
          } else {
            toast.error(res.response.message)
            // setOtpSubmitalertObject({ type: 'FailedAlert', text: "Invalid OTP" })
            // setshowOtpSubmitAlert(true);
            // setTimeout(() => {
            //   setshowOtpSubmitAlert(false);
            //   setOtpSubmitalertObject({});
            // }, 3000);
          }
        }

      }
      catch (e) {
      }
    }
  }
  useEffect(() => {
    handleOTPSubmitSuceess();
  }, [pin1, pin2, pin3, pin4, pin5, pin6]);

  const onChangeOTP = (e) => {
    setIsOTP(isOTP);
  };

  //Preview Button
  const handlePreviewBtn = () => {
    
    if (mobileNoVerified == false) {
      toast.error("Mobile no verification is required.")
      return;
    }
    // Validation for Select Persona    
    if (!selectedPersona.id) {
      toast.error("Select Persona is required.");
      return;
    } else {
      setPersonaValidationError("");
    }

    // Validation for first name
    if (!user.nameKYC && !isValidFullName(user.nameKYC)) {
      toast.error("User's full name is required.");
      return;
    } else {
      setNameValidationError("");
    }

    if(!userDoB) {
      toast.error("Date of birth is required.");
      return;
    }

    if(!user.useraddress) {
      
      toast.error("Address is required.");
      return;
    }

    // Validation for Brand
    if (!selectedBrand.id) {
      toast.error("Select Brand is required.");
      return;
    }
    // Validation for mobile number
    if (!user.mobile && !isValidMobileNumber(user.mobile)) {
      toast.error("Valid mobile number is required.");
      return;
    } else {
      setMobileValidationError("");
    }

    if (emailValidationError) {
      toast.error(emailValidationError);
      return;
    } else {
      // setEmailValidationError("");
    }

    if(!selectedState.id) {
      toast.error("State cannot be empty");
      return;
    }
    if(!selectedDistrict.id) {
      toast.error("District cannot be empty");
      return;
    }
    if(!selectedTaluka.id) {
      toast.error("Taluka cannot be empty");
      return;
    }
    if(!selectedOfficer.id) {
      toast.error("TSE or Dealer is required");
      return;
    }
    if(selectedOfficer.id == "TSE" && !selectedOffMember.id) {
      toast.error("Please enter TSE");
      return;
    }
    if(selectedOfficer.id == "Dealer" && !selectedOffMember.id) {
      toast.error("Please enter Dealer");
      return;
    }
    if(!selectedMarritalStatus.id) {
      toast.error("Marital status cannot be empty");
      return;
    }
    if(selectedMarritalStatus.id == "Married" && (!spouseDoB || !user.spouseName || !marriageAnniversary)) {
      toast.error("Spouse information and marriage anniversary cannot be empty");
      return;
    }

    // Validation for selected KYC
    if (!selectedKYC.id) {
      toast.error("Select KYC is required.");
      return;
    } else {
      setKycValidationError("");
    }

    // Validation for KYC Details
    if (!user.kycDetails) {
      toast.error("KYC Details is required.");
      return;
    } else {
      setKycDetailsValidationError("");
    }

    if(selectedKYC.id == "pan" && !panImage) {
      toast.error("Pan image required");
      return;
    }
    if((selectedKYC.id != "pan" && selectedKYC.id != "") && (!frontImage || !backImage)) {
      toast.error("Kyc front and back image required");
      return;
    }
    if(!profileImage) {
      toast.error("Kyc front and back image required");
      return;
    }

    if(!isChecked || !isAgreedChecked) {
      toast.error("Please mark both the checkboxes");
      return;
    }

    // Check if all validations are true
    handleRegister();
  };
  
  //Register Button
  function handleRegister() {
    let isValid = true;
  
    if (!isValid) {
      return;
    }
  
    const allowedTypes = ["image/jpeg", "image/jpg"];
  
    if (selectedKYC.id === "pan") {
      if (panImage && !allowedTypes.includes(panImage.file.type)) {
        toast.error("Only JPG, JPEG files are allowed for PAN upload.");
        return;
      }
    } else {
      if (frontImage && !allowedTypes.includes(frontImage.file.type)) {
        toast.error("Only JPG, JPEG files are allowed for front image.");
        return;
      }
      if (backImage && !allowedTypes.includes(backImage.file.type)) {
        toast.error("Only JPG, JPEG, or PNG files are allowed for back image.");
        return;
      }
    }
  
    if (profileImage && !allowedTypes.includes(profileImage.file.type)) {
      toast.error("Only JPG, JPEG files are allowed for profile image.");
      return;
    }
      let payload = {
      full_name: user.nameKYC,
      mobile_number: user.mobile,
      email_address: user.email,
      gender: "M",
      hierarchies_id: selectedPersona.id,
      createdby_hierarchies_id: 0,
      created_by: 0,
      identity_number: user.kycDetails,
      identity_number_type: selectedKYC.id,
      marital_status: selectedMarritalStatus.id,
      company_establishment_name: "TSS",
      organization_Id: 2,
      brand_Id: selectedBrand.id,
      GSTN: "",
      sap_code: null,
      is_approved: null,
      approved_by: null,
      dcm_languages_id: null,
      can_redeem: null,
      approved_at: null,
      verified_by: "0",
      select_TSE_or_dealer: selectedOfficer.id,
      active_sites: '4',
      address: user.useraddress,
      brand_id: parseInt(selectedBrand.id),
      city_id: Number(selectedDistrict.id),
      country_id: selectedCountry.id,
      date_of_birth: userDoB,
      landmark: null,
      marraige_anniversary: ddmmyyyyToyyyymmdd(marriageAnniversary),
      pin_code: null,
      post_office: null,
      spouse_birthday: ddmmyyyyToyyyymmdd(spouseDoB),
      spouse_name: user.spouseName,
      state_id: selectedState.id,
      taluka_id: selectedTaluka.id,
      token: verifyOtpToken,
      // referral_code: referralCode || "",
      // refeferalCode: referralCode || "",
      identity_number: fetchKYCInfoResponse?.response?.KYCDetails?.documentNumber,
      frontFilePath: fetchKYCInfoResponse?.response?.KYCDetails?.frontFilePath,
      backFilePath: fetchKYCInfoResponse?.response?.KYCDetails?.backFilePath,
      identity_number_type: fetchKYCInfoResponse?.response?.KYCDetails?.kycType,
      details: JSON.stringify(fetchKYCInfoResponse?.response?.KYCDetails?.details),
      doccument_json: JSON.stringify(fetchKYCInfoResponse?.response?.KYCDetails?.doccument_json),
    };
    
    if (selectedOfficer.id === 'TSE') {
      payload = { ...payload, tse_id: selectedOffMember.id };
    }
    if (selectedOfficer.id === 'Dealer') {
      payload = { ...payload, dealer_arr: [selectedOffMember.id] };
    }
    
  
    setIsButtonLoading(true);
  
    RegistrationService.registrationTemporaryAndBasic(payload)
      .then((res) => {
        if (res.success) {
          setregistrationSubmitResponse(res);
          setShowRegistrationAlert(true);
  
          const contactId = res?.response?.data?.id;
          
          // Upload profile image
          if (profileImage) {
            const profileFormData = new FormData();
            profileFormData.append("contact_id", contactId);
            profileFormData.append("profile_image", profileImage.file);
            
            RegistrationService.uploadProfileImageNode(profileFormData)
              .then(profileRes => {
              })
              .catch(profileErr => {
              });
          }
          
          const formData = new FormData();
  
          if (selectedKYC.id === "pan") {
            if (panImage) {
              formData.append("pan_image", panImage.file);
            }
          } else {
            if (frontImage) formData.append("front_image", frontImage.file);
            if (backImage) formData.append("back_image", backImage.file);
          }
  
          formData.append("profile_image", profileImage.file);
          formData.append("KYCType", selectedKYC.id);
          formData.append("KYCDetails", user.kycDetails);
          formData.append("contact_id", contactId);
  
          // RegistrationService.updateKYCDetails(formData)
          //   .then(res => {
              if (res.success) {
                toast.success('Registered successfully');
                navigate('/');
                setIsButtonLoading(false);
              } else {
                toast.error('Error occurred while uploading KYC!');
                setIsButtonLoading(false);
              }
          //   })
          //   .catch(err => {

          //     toast.error('Error occurred while uploading KYC!');
          //   })
          //   .finally(() => {
              // setIsButtonLoading(false);
          //   });
        } else {
          setIsButtonLoading(false);
          if (res.response.message) {
            toast.error(res.response.message);
          }
        }
      })
      .catch((error) => {
        console.error("Error registering:");
        setIsButtonLoading(false);
        if (error.response?.error) {
          const keys = Object.keys(error.response.error);
          keys.forEach(key => {
            toast.error(error.response.error[key]);
          });
        }
      });
  }
  
  

  //Functions
  const isValidFullName = (fullName) => {
    // Ensure there are at least two words (first name and last name)
    const nameParts = fullName.trim().split(" ");

    return nameParts.length >= 2;

  };

  const isValidMobileNumber = (mobileNumber) => {
    const mobileNumberPattern = /^(\+\d{1,3}[- ]?)?[6-9]\d{9}$/;
    return mobileNumberPattern.test(mobileNumber);
  };

  // Fetch KYC Info from Document Images
  const fetchInfo = async () => {
    if(selectedKYC.id === 'pan') {
      if(!panImage) {
        toast.error(`Please provide ${selectedKYC.title} image`);
        return;
      }
    } else {
      if(!frontImage || !backImage) {
        toast.error(`Please provide ${selectedKYC.title} front and back images`);
        return;
      }
    }

    const fd = new FormData();
    if(frontImage || panImage) {
      const img1 = frontImage ? frontImage.file : panImage.file;
      fd.append('ekyc_front_image', img1);
    }
    if(backImage) {
      const img2 = backImage.file;
      fd.append('ekyc_back_image', img2);
    }
    fd.append('KYCType', selectedKYC.fetchDocId);
    fd.append('doc_number', user.kycDetails.toUpperCase().trim());
    
    // Convert date format from YYYY-MM-DD to DD-MM-YYYY
    const [yyyy, mm, dd] = userDoB.split('-');
    fd.append('dob', `${dd}-${mm}-${yyyy}`);

    setIsButtonLoading(true);
    try {
      
      
      const res = await RegistrationService.fetchKYCInfo(fd);
      setIsButtonLoading(false);
      
      if(res.success) {
        const data = res.response.KYCDetails;
        setUser(prev => ({...prev, nameKYC: data.name}));
        toast.success(res.message || "KYC info fetched successfully");
        setKycUploadBlock(true);
        setIsKYCVerified(true);
        setIsNameReadOnly(!!data.name);
        setFetchKYCInfoResponse(res);
        setDisabledBlock(false);
      } else {
        toast.error(res.response?.message || 'Unable to fetch KYC info from the document images. Please enter details manually.');
        setKycUploadBlock(false);
        setIsKYCVerified(false);
        setFetchKYCInfoResponse(null);
        setDisabledBlock(true);
      }
    } catch(err) {
      setIsButtonLoading(false);
      toast.error(err?.message || 'Error while fetching KYC info');
      setKycUploadBlock(false);
      setIsKYCVerified(false);
      setFetchKYCInfoResponse(null);
      setDisabledBlock(true);
    }
  };

  //Edit Registration
  const handleEditRegistration = () => {
    setPreviewBlock(false);
    setRegFormBlock(true);
  };
  // const setProfileImageHandler = (profileImg) => {
  //   setProfileImage(profileImg)
  //   setProfilePicNotNotUploadedAlert("");
  // }

  // const setPanImageHandler = (pan) => {
  //   setPanImage(pan)
  //   setfileNotUploadedAlert("");
  // }

  const setOtherKYCFrontImageHandler = (frontImage) => {
    setFrontImage(frontImage)
    setfileNotUploadedFrontAlert('')
  }
  const setOtherKYCBackImageHandler = (backImage) => {
    setBackImage(backImage)
    setfileNotUploadedBackAlert('')
  }

  useEffect(() => {
    const fetchTermsContent = async () => {
      try {
        const response = await RegistrationService.contentSpotUnauthorised('TermsAndConditionMobileAppNoAuth');
        
        if (
          response &&
          !response.error &&
          response.data?.content_banner_details_contact?.content_spot_contents?.length
        ) {
          const articleDetail = response.data.content_banner_details_contact.content_spot_contents[0].article_detail;
          setTermsContent(articleDetail || 'No terms available.');
        } else {
          setTermsContent('No terms available.');
        }
      } catch (error) {
        console.error('Error fetching terms content:');
        setTermsContent('Error loading terms.');
      }
    };

    fetchTermsContent();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setIsModalOpen(false);
      }
    };

    if (isModalOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isModalOpen]);
  
  return (
    <>
      <div className="loginBg">
        <div className="p-0 registrationImgBlock stickyBlock">
          <PreLoginBanner />
        </div>
        <div className="p-0 registrationFromBlock">

          <div className="loginFromsBlock">
            {regFormBlock && (
              <div className="rightLoginForm">
                <div className="frm-login">
                  <div className="formBlock">
                    <PurpleHeading purpleHeadingText="Register to unlock unlimited rewards" />
                    <SelectDropDownNew
                      labelName="Persona"
                      requiredStar="*"
                      page='searchFilter'
                      options={persona}
                      onChange={handlePersonaChange}
                      selectedValue={selectedPersona}
                      setSelectedValue={setSelectedPersona}
                      required
                      openDropdown={openDropdown}
                      setOpenDropdown={setOpenDropdown}
                    />
                    {personaValidationError && (
                      <div className="error-message">
                        {personaValidationError}
                      </div>
                    )}

                    <div className="mb-1 mt-3" >
                      <SelectDropDownNew
                        labelName="Select Brand"
                        requiredStar="*"
                        options={isbrand}
                        onChange={handleBrandChange}
                        selectedValue={selectedBrand}
                        setSelectedValue={setSelectedBrand}
                        required
                        openDropdown={openDropdown}
                        setOpenDropdown={setOpenDropdown}
                      />
                      {/* {brandValidationError && (
                        <div className="error-message">
                          {brandValidationError}
                        </div>
                      )} */}
                    </div>

                    <div className="my-3">
                      <InputField inputFieldLabel="Referral code"
                        autocomplete="off"
                        value={user.refeferalCode}
                        onChange={handleRegistrationInputs}
                        name="refeferalCode"
                        required />
                    </div>

                    <div className="mb-1 mt-3" >
                      <DatePicker
                        inputFieldLabel="Date of Birth as per document"
                        value={userDoB}
                        onChange={setUserDoB}
                        name="dob"
                        dobSelection={true}
                        requiredStar="*"
                        
                      />
                    </div>

                    <SelectDropDownNew
                      labelName="KYC Type"
                      requiredStar="*"
                      options={documentTypeOptions}
                      onChange={handleKYCChange}
                      selectedValue={selectedKYC}
                      setSelectedValue={setSelectedKYC}
                      name="selectKYC"
                      openDropdown={openDropdown}
                      setOpenDropdown={setOpenDropdown}
                    />

                    <div
                        className="leftFullWidthInput upperKYCDetails"
                      // style={{
                      //   pointerEvents: selectedKYC == "" ? "none" : "auto",
                      //   opacity: selectedKYC == "" ? 0.4 : 1,
                      // }}
                      >
                        <InputField
                          inputFieldLabel="KYC Details"
                          requiredStar="*"
                          autocomplete="off"
                          value={user.kycDetails}
                          onChange={handleRegistrationInputs}
                          name="kycDetails"
                          required
                        />
                      </div>

                    {selectedKYC.id && (
                      <div className="mt-3">
                        {selectedKYC.id === "pan" && (
                          <>
                            <UploadFile
                              key={`pan-${selectedKYC.id || ''}`}
                              label="Upload PAN"
                              requiredStar="*"
                              accept="image/jpeg, image/jpg"
                              value={panImage}
                              setValue={setPanImage}
                            />
                            {fileNotUploadedAlert && (
                              <div className="error-message fileUploadMsg">
                                {fileNotUploadedAlert}
                              </div>
                            )}
                          </>
                        )}

                        {selectedKYC.id !== "pan" && (
                          <>
                            <div className="mt-3">
                              <UploadFile
                                key={`front-${selectedKYC.id || ''}`}
                                label={`Upload ${selectedKYC.title} Front`}
                                requiredStar="*"
                                accept="image/jpeg, image/jpg ,image/png"
                                setValue={setFrontImage}
                                value={frontImage}
                              />
                              {fileNotUploadedFrontAlert && (
                                <div className="error-message fileUploadMsg">
                                  {fileNotUploadedFrontAlert}
                                </div>
                              )}
                              <UploadFile
                                key={`back-${selectedKYC.id || ''}`}
                                label={`Upload ${selectedKYC.title} Back`}
                                requiredStar="*"
                                accept="image/jpeg, image/jpg, image/png"
                                setValue={setBackImage}
                                value={backImage}
                              />
                              {fileNotUploadedBackAlert && (
                                <div className="error-message fileUploadMsg">
                                  {fileNotUploadedBackAlert}
                                </div>
                              )}
                            </div>
                          </>
                        )}

                        <UploadFile
                          key={`profile-${selectedKYC.id || ''}`}
                          label='Profile Picture'
                          requiredStar="*"
                          accept="image/jpeg, image/jpg, image/png"
                          value={profileImage}
                          setValue={setProfileImage}
                        />
                        {profilePicNotUploadedAlert && (
                          <div className="error-message fileUploadMsg">
                            {profilePicNotUploadedAlert}
                          </div>
                        )}
                      </div>
                    )}

                    <div className="registrationTopText flexWrapBox">
                      <div className="linkColor mob-linkColor mt-3" onClick={fetchInfo}>
                        <u>Upload Now</u>
                      </div>
                    </div>

                    <div className="mb-3">
                      <InputField
                        inputFieldLabel="Name as per Govt. ID"
                        requiredStar="*"
                        value={user.nameKYC}
                        onChange={handleRegistrationInputs}
                        name="nameKYC"
                        autocomplete="off"
                        required
                        readOnly={isNameReadOnly}
                        disabled={disabledBlock || isNameReadOnly}
                      />
                      {/* {nameValidationError && (
                        <div className="error-message">
                          {nameValidationError}
                        </div>
                      )} */}
                    </div>
                    <div className="mb-3">
                      <InputField
                        inputFieldLabel="Email"
                        value={user.email}
                        onChange={handleRegistrationInputs}
                        name="email"
                        autocomplete="off"
                        disabled={disabledBlock}
                      />
                      {/* {emailValidationError && (
                        <div className="error-message">
                          {emailValidationError}
                        </div>
                      )} */}
                    </div>
                    <div className="mb-3">
                      <div className="registrationTopText flexWrapBox">
                        <div className="leftFullWidthInput">
                          <InputField
                            inputFieldLabel="Mobile No"
                            requiredStar="*"
                            autocomplete="off"
                            value={user.mobile}
                            onChange={handleRegistrationInputs}
                            name="mobile"
                            disabled={disabledBlock}
                            maxLength={10}
                          />
                        </div>
                        <div className="linkColor mob-linkColor mt-3" onClick={handleOTPSubmit}>
                          <u>Verify Now</u>
                        </div>

                        {showAlert && (
                          <div className="mt-2">
                            <AlertMsg
                              alertBoxColor={
                                verifyPhoneNumberObject.success
                                  ? "successAlert"
                                  : "FailedAlert"
                              }
                              heading={""}
                              text={verifyPhoneNumberObject.response.message}
                            />
                          </div>
                        )}
                         <div className="w-100"> 
                          {mobileValidationError && (
                            <div className="error-message">
                              {mobileValidationError}
                            </div>
                          )}
                         </div>
                         <div className="w-100">
                          {mobileOTPValidationError && (
                            <div className="error-message">
                              {mobileOTPValidationError}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    {showAlertOTP && (
                      <div className="alertBoxWrap mt-3 w-100">
                        <AlertMsg
                          alertBoxColor={
                            isLoginSuccess.isLogin
                              ? "successAlert"
                              : "FailedAlert"
                          }

                          text={isLoginSuccess.text}
                        />
                      </div>
                    )}
                    {isOTPBlock && (
                      <>
                        <div className="registrationTopText">
                          <div className="otpBox">
                            <OTPBox
                              pin1={pin1}
                              pin2={pin2}
                              pin3={pin3}
                              pin4={pin4}
                              pin5={pin5}
                              pin6={pin6}
                              setPin1={setPin1}
                              setPin2={setPin2}
                              setPin3={setPin3}
                              setPin4={setPin4}
                              setPin5={setPin5}
                              setPin6={setPin6}
                            />
                          </div>

                        </div>
                        <div className="registrationTopText flexWrapBox mt-3">
                          <div className="leftFullWidthInput">
                            <PrimaryGradientButton buttonText="Verify OTP" onClick={handleOTPSubmitSuceess} />
                          </div>
                          <div className="linkColor mob-linkColor mt-3" onClick={handleOTPReSubmit}>
                            <u>Resend OTP</u>
                          </div>

                          {/* {mobileValidationError && (
                            <div className="error-message">
                              {mobileValidationError}
                            </div>
                          )} */}

                        </div>

                      </>
                    )}

                    {showOtpSubmitAlert && (
                      <div className="mt-2">
                        <AlertMsg
                          alertBoxColor={otpSubmitalertObject.type}
                          heading={"Success"}
                          text={otpSubmitalertObject.text}
                        />
                      </div>
                    )}

                    <div className="mb-1 mt-3" >
                      <SelectDropDownNew
                        page='searchFilter'
                        labelName="Select State"
                        requiredStar="*"
                        options={allState}
                        // onChange={handleBrandChange}
                        selectedValue={selectedState}
                        setSelectedValue={setSelectedState}
                        required
                        openDropdown={openDropdown}
                        setOpenDropdown={setOpenDropdown}
                        disabled={disabledBlock}
                      />
                      {/* {brandValidationError && (
                        <div className="error-message">
                          {brandValidationError}
                        </div>
                      )} */}
                    </div>
                    <div className="mb-1 mt-3" >
                      <SelectDropDownNew
                        page='searchFilter'
                        labelName="Select District"
                        requiredStar="*"
                        options={allDistrict}
                        // onChange={handleBrandChange}
                        selectedValue={selectedDistrict}
                        setSelectedValue={setSelectedDistrict}
                        required
                        openDropdown={openDropdown}
                        setOpenDropdown={setOpenDropdown}
                        disabled={disabledBlock}
                      />
                      {/* {brandValidationError && (
                        <div className="error-message">
                          {brandValidationError}
                        </div>
                      )} */}
                    </div>
                    <div className="mb-1 mt-3" >
                      <SelectDropDownNew
                        page='searchFilter'
                        labelName="Select Taluka"
                        requiredStar="*"
                        options={allTaluka}
                        // onChange={handleBrandChange}
                        selectedValue={selectedTaluka}
                        setSelectedValue={setSelectedTaluka}
                        required
                        openDropdown={openDropdown}
                        setOpenDropdown={setOpenDropdown}
                        disabled={disabledBlock}
                      />
                      {/* {brandValidationError && (
                        <div className="error-message">
                          {brandValidationError}
                        </div>
                      )} */}
                    </div>
                    <div className="mb-1 mt-3" >
                      <SelectDropDownNew
                        labelName="Select Dealer or TSE"
                        requiredStar="*"
                        options={dealerOrTse}
                        // onChange={handleBrandChange}
                        selectedValue={selectedOfficer}
                        setSelectedValue={setSelectedOfficer}
                        required
                        openDropdown={openDropdown}
                        setOpenDropdown={setOpenDropdown}
                        disabled={disabledBlock}
                      />
                      {/* {brandValidationError && (
                        <div className="error-message">
                          {brandValidationError}
                        </div>
                      )} */}
                    </div>
                    {selectedOfficer.id && <div className="mb-1 mt-3" >
                      <SelectDropDownNew
                        labelName={`Select ${selectedOfficer.title}`}
                        requiredStar="*"
                        options={allOffMember}
                        // onChange={handleBrandChange}
                        selectedValue={selectedOffMember}
                        setSelectedValue={setSelectedOffMember}
                        required
                        openDropdown={openDropdown}
                        setOpenDropdown={setOpenDropdown}
                        disabled={disabledBlock}
                      />
                      {/* {brandValidationError && (
                        <div className="error-message">
                          {brandValidationError}
                        </div>
                      )} */}
                    </div>}
                    <div className="my-3">
                      <InputField
                        inputFieldLabel="Address"
                        autocomplete="off"
                        requiredStar="*"
                        value={user.useraddress}
                        onChange={handleRegistrationInputs}
                        name="useraddress"
                        disabled={disabledBlock}
                        required />
                    </div>
                    <div className="mb-1 mt-3" >
                      <SelectDropDownNew
                        labelName="Marital Status"
                        requiredStar="*"
                        options={maritalStatusList}
                        // onChange={handleBrandChange}
                        selectedValue={selectedMarritalStatus}
                        setSelectedValue={setSelectedMarritalStatus}
                        required
                        openDropdown={openDropdown}
                        setOpenDropdown={setOpenDropdown}
                        disabled={disabledBlock}
                      />
                      {/* {brandValidationError && (
                        <div className="error-message">
                          {brandValidationError}
                        </div>
                      )} */}
                    </div>
                    {selectedMarritalStatus.title=="Married" && <div className="mb-1 mt-3" >
                      <DatePicker
                        inputFieldLabel="Marriage Anniversary"
                        requiredStar="*"
                        onChange={setMarriageAnniversary}
                        value={marriageAnniversary}
                        required
                        disabled={disabledBlock}
                      />
                      {/* {brandValidationError && (
                        <div className="error-message">
                          {brandValidationError}
                        </div>
                      )} */}
                    </div>}
                    {selectedMarritalStatus.title=="Married" && <div className="mb-1 mt-3" >
                      <InputField
                        inputFieldLabel="Spouse Name"
                        value={user.spouseName}
                        requiredStar="*"
                        onChange={handleRegistrationInputs}
                        name="spouseName"
                        autocomplete="off"
                        disabled={disabledBlock}
                      />

                      {/* {brandValidationError && (
                        <div className="error-message">
                          {brandValidationError}
                        </div>
                      )} */}
                    </div>}
                    {selectedMarritalStatus.title=="Married" && <div className="mb-1 mt-3" >
                      <DatePicker
                        inputFieldLabel="Spouse DoB"
                        value={spouseDoB}
                        requiredStar="*"
                        onChange={setSpouseDoB}
                        name="spouse dob"
                        dobSelection={true}
                        disabled={disabledBlock}
                      />
                      {/* {brandValidationError && (
                        <div className="error-message">
                          {brandValidationError}
                        </div>
                      )} */}
                    </div>}
                    {/* <SelectDropDownNew
                      labelName="KYC Type"
                      requiredStar="*"
                      options={documentType}
                      onChange={handleKYCChange}
                      selectedValue={selectedKYC}
                      setSelectedValue={setSelectedKYC}
                      name="selectKYC"
                      openDropdown={openDropdown}
                      setOpenDropdown={setOpenDropdown}
                    /> */}

                    {/* {kycValidationError && (
                      <div className="error-message">{kycValidationError}</div>
                    )} */}

                    <div className="my-3 checkTxt">
                          <input
                            type="checkbox"
                            className="checkTxtBox"
                            checked={isChecked}
                            onChange={handleCheckboxChange}
                          />
                          <span>
                            The information provided above are true to my knowledge & I hereby solemnly submit all the documents required. All details captured will be solely used for the purpose of CRMS & Loyalty program only.
                          </span>
                          {checkBoxValidationAlert && (
                            <div className="error-message">
                              {checkBoxValidationAlert}
                            </div>
                          )}
                        </div>

                        <div className="my-3 checkTxt">
                          <input
                            type="checkbox"
                            className="checkTxtBox"
                            checked={isAgreedChecked}
                            onChange={handleAgreeCheckboxChange}
                          />

                      <span>
        I have read & agreed to the{' '}
        <span
          onClick={() => setIsModalOpen(true)}
          style={{ color: '#3B82F6', textDecoration: 'underline', cursor: 'pointer' }}
        >
          terms of service & privacy policy
        </span>
      </span>

      {isModalOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
          }}
        >
          <div
            ref={modalRef}
            style={{
              backgroundColor: 'white',
              padding: '20px',
              borderRadius: '8px',
              maxWidth: '600px',
              maxHeight: '80%',
              overflowY: 'auto',
              boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
            }}
          >
            <h3>Terms of Service & Privacy Policy</h3>
            {/* <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(termsContent) }} /> */}
            <div>
              {parseSafeHtml(termsContent)}
            </div>
            <button
              onClick={() => setIsModalOpen(false)}
              style={{
                marginTop: '20px',
                padding: '10px 20px',
                backgroundColor: '#3B82F6',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}

                          {agreedCheckBoxValidationAlert && (
                            <div className="error-message">
                              {agreedCheckBoxValidationAlert}
                            </div>
                          )}
                        </div>

                    

                    {/* {fileNotUploadedAlert && (
                      <div className="mt-2">
                        <AlertMsg
                          alertBoxColor={
                            fileNotUploadedAlert.success ?
                              "successAlert" :
                              "FailedAlert"
                          }
                          heading={""}
                          text={
                            fileNotUploadedAlert.message
                          }
                        />
                      </div>
                    )} */}

                    <PrimaryGradientButton
                      buttonText="Register Now"
                      onClick={handlePreviewBtn}
                      className="mt-5"
                      loading={isButtonLoading}
                      disabled={!isKYCVerified || isKYCVerifying}
                    />
                    <p className="orText mt-20">Or</p>
                    <Link to="/" className="noTextDecoration">
                      <PrimaryOutLineButton
                        outlinebuttonText="Login Now"
                        className="mt-20"
                      />
                    </Link>
                  </div>
                </div>
              </div>
            )}
          
            {/* Registration Form Data Show  */}
            {previewBlock && (
              <div className="rightLoginForm">
                <div className="frm-login">
                  <div className="formBlock">
                    <PurpleHeading purpleHeadingText="Please check your details before submit" />
                    <div className="registrationTopText">
                      <RegistrationUserInputField
                        className="registrationTextLabel"
                        formLabel="Persona"
                        requiredStar="*"
                      />
                      <RegistrationUserInputField
                        className="registrationTextData"
                        formLabel={selectedPersona.title}
                      />
                    </div>
                    <div className="registrationTopText">
                      <RegistrationUserInputField
                        className="registrationTextLabel"
                        formLabel="Name as per Govt. ID"
                        requiredStar="*"
                      />
                      <RegistrationUserInputField
                        className="registrationTextData"
                        formLabel={user.nameKYC}
                      />
                    </div>
                    <div className="registrationTopText">
                      <RegistrationUserInputField
                        className="registrationTextLabel"
                        formLabel="Mobile No"
                        requiredStar="*"
                      />
                      <RegistrationUserInputField
                        className="registrationTextData"
                        formLabel={user.mobile}
                      />
                    </div>
                    <div className="registrationTopText">
                      <RegistrationUserInputField
                        className="registrationTextLabel"
                        formLabel="KYC Type"
                        requiredStar="*"
                      />
                      <RegistrationUserInputField
                        className="registrationTextData"
                        formLabel={selectedKYC.id}
                      />
                    </div>
                    <div className="registrationTopText">
                      <RegistrationUserInputField
                        className="registrationTextLabel"
                        formLabel="KYC Details"
                        requiredStar="*"
                      />
                      <RegistrationUserInputField
                        className="registrationTextData"
                        formLabel={user.kycDetails}
                      />
                    </div>
                    {/* <div className='registrationTopText'>
                        <RegistrationUserInputField className="registrationTextLabel" formLabel="Uploaded Files" requiredStar="*" />
                        <RegistrationUserInputField className="registrationTextData" formLabel={frontImage.uri} />
                  </div> */}
                    <div
                      className="registrationTopText"
                      style={{ width: "100% " }}
                    >
                      <RegistrationUserInputField
                        className="registrationTextLabel"
                        formLabel="Uploaded Files"
                        requiredStar="*"
                      />

                      <div className="registrationTextData uploadedImage">

                        {selectedKYC.id === "pan" && (
                          <img
                            src={panImage.file}
                            alt={selectedKYC.title}

                          ></img>
                        )}
                        {selectedKYC.id !== "pan" && (
                          <>
                            <img
                              src={frontImage.file}
                              alt={`${selectedKYC.title} ${frontImage.value}`}

                            ></img>
                            <img
                              src={backImage.file}
                              alt={`${selectedKYC.title} ${frontImage.value}`}

                            ></img>
                          </>
                        )}
                        <>
                          <img
                            src={profileImage.file}
                            alt="Profile Image"

                          ></img></>
                      </div>

                    </div>

                    <div className="registrationTopText">
                      <RegistrationUserInputField
                        className="registrationTextLabel"
                        formLabel="Referral Code"
                        requiredStar="*"
                      />
                      <RegistrationUserInputField
                        className="registrationTextData"
                        formLabel={user.refeferalCode}
                      />
                    </div>

                    <PrimaryGradientButton
                      buttonText={isButtonLoading ? "Processing..." : "Submit"}
                      onClick={handleRegister}
                      disabled={isButtonLoading}
                      loading={true}
                    />

                    <div className="noTextDecoration">
                      <PrimaryOutLineButton
                        outlinebuttonText="Edit Registration Form"
                        className="mt-20"
                        onClick={handleEditRegistration}
                      />
                    </div>
                    {/* {showRegistrationAlert && (
                      <div className="mt-2">
                        <AlertMsg
                          alertBoxColor={
                            registrationSubmitResponse.success
                              ? "successAlert"
                              : "FailedAlert"
                          }
                          heading={""}
                          text={
                            registrationSubmitResponse.success
                              ? registrationSubmitResponse.response.message
                              : errorMessagesAfterRegistration
                          }
                        />
                      </div>
                    )} */}

                  </div>
                </div>
              </div>
            )}
          </div>

        </div>
      </div>
    </>
  );
};

export default Registration;
